@import '../../../theme.scss';

verdocs-delegate-dialog {
  font-family: $primary-font;
  box-sizing: border-box;

  div {
    box-sizing: border-box;
  }

  .heading .icon {
    /* Ensure the icon takes the variable color. The SVG inside should use fill: currentColor or just inherit/use fill: var(...) if set here */
    svg {
      fill: var(--verdocs-dialog-icon-color, #ffffff);
    }
  }

  /* New Form Layout Classes */
  .verdocs-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  .verdocs-form-row {
    display: flex;
    gap: 16px;
    width: 100%;

    > * {
      flex: 1;
    }
  }

  .verdocs-form-label {
    font-size: 13px;
    line-height: 20px;
    font-weight: 300;
    color: var(--verdocs-label-color, #616161);
    margin-bottom: 2px;
    display: block;
  }

  .verdocs-form-input {
    border: 1px solid #d1d1d1;
    border-bottom-color: var(--verdocs-input-border-bottom-color, #d1d1d1);
    border-radius: 4px;
    color: #707070;
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;

    &::placeholder {
      color: #9ca3af;
    }

    &:focus {
      outline: none;
      border-color: var(--verdocs-primary-color, $verdocs-purple);
    }
  }

  .buttons {
    gap: 12px;
    display: flex;
    margin-top: 0;
    flex-direction: row;
    justify-content: flex-end;

    button {
      padding: 8px 16px;
      height: 40px;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      align-items: center;
      border-radius: var(--verdocs-button-radius, 4px);
      justify-content: center;
      transition: all 0.2s ease;

      &.cancel {
        background-color: transparent;
        border: var(--verdocs-button-secondary-border, 1px solid #d1d5db);
        color: var(--verdocs-button-secondary-color, #374151);
      }

      &.proceed {
        background-color: var(--verdocs-primary-color, $verdocs-green);
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background-color: var(--verdocs-primary-color-hover, $verdocs-green-shade);
        }
      }

      &:disabled {
        background-color: var(--verdocs-button-disabled-bg, #e5e7eb);
        color: var(--verdocs-button-disabled-color, #9ca3af);
        cursor: not-allowed;
      }
    }
  }
}
